import React from 'react';

function About(props) {
  return <header className={['pageHeader', props.nobg ? 'nobg' : '', props.overflow ? 'overflow' : ''].join(' ')}>{props.children}</header>;
}

export default About;
